<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-3 col-lg-4">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class="header-title">
                            <h4 class="card-title">Add New Tag</h4>
                        </div>
                    </div>
                    
                    <div class="card-body">
                        <form>
                            <div class="form-group">
                                <label for="name">Name:</label>
                                <b-form-input type="text" id="id" placeholder="Tag Name" :class="`form-control ${$v.tagForm.tag.name.$error ? 'is-invalid' : ''}`" 
                                    v-model="tagForm.tag.name" @input="$v.tagForm.tag.name.$touch()" @blur="$v.tagForm.tag.name.$touch()" required></b-form-input>
                                <div class="invalid-feedback"><small>Required field</small></div>
                            </div>
                           
                            <div class="form-group">
                                <label for="description">Description:</label>
                                <b-form-input type="text" id="description" placeholder="Tag Description" :class="`form-control ${$v.tagForm.tag.description.$error ? 'is-invalid' : ''}`"
                                    v-model="tagForm.tag.description" @input="$v.tagForm.tag.description.$touch()" @blur="$v.tagForm.tag.description.$touch()" required></b-form-input>
                                <div class="invalid-feedback"><small>Required field</small></div>
                            </div>

                            <div class="form-group">
                                <label for="orderby">Order:</label>
                                <b-form-input type="number" min="1" id="orderby" placeholder="Tag Order" :class="`form-control ${$v.tagForm.tag.orderby.$error ? 'is-invalid' : ''}`"
                                    v-model="tagForm.tag.orderby" @input="$v.tagForm.tag.orderby.$touch()" @blur="$v.tagForm.tag.orderby.$touch()" required></b-form-input>
                                <div class="invalid-feedback"><small>Required field</small></div>
                                <div class="invalid-feedback" v-if="!$v.tagForm.tag.orderby.minValue"><small>Order cannot be negative value</small></div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="col-xl-9 col-lg-8">
                <div class="card">
                    <div class="card-header d-flex justify-content-between">
                        <div class="header-title">
                            <h4 class="card-title col-md-12 mt-3">New Tag Information</h4>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12 mb-3">
                            <h5 class="mb-3 col-md-12 mx-0 px-0">Games Order</h5>

                            <div class="row">
                                <div class="col-6">
                                    <h6 class="mb-3 col-md-12">Selected Games</h6>
                                    <div class="vh-100 border rounded border-secondary">
                                        <draggable class="list-group w-100" :list="tagForm.games" group="games">
                                            <div class="list-group-item" v-for="(element, index) in tagForm.games" :key="element.name">
                                                <div class="row">
                                                    <div class="d-flex flex-row align-items-center col-md-8 col-lg-10">
                                                        <p class="my-0 py-0 text-truncate" v-b-tooltip.hover :title="element.name" triggers="hover">{{element.name}}</p>
                                                    </div>
                                                    <div class="d-flex flex-row-reverse align-items-center col-md-4 col-lg-2 mx-0 px-0">
                                                        <b-button variant="outline-danger" class="border-none ml-2" @click="remove(element)"><i class="las la-times-circle m-0 p-0"></i></b-button>
                                                        {{index + 1}}
                                                    </div>
                                                </div>
                                            </div>
                                        </draggable>
                                    </div>
                                </div>

                                <div class="col-6">
                                    <h6 class="mb-3 col-md-12">Available Games</h6>
                                    <div class="min-vh-100 border rounded border-secondary">
                                        <draggable class="list-group w-100" :list="gameList" group="games">
                                            <div class="list-group-item" v-for="(element, index) in gameList" :key="element.name">
                                                <div class="row">
                                                    <div class="d-flex flex-row align-items-center col-md-8 col-lg-10">
                                                        <p class="my-0 py-0 text-truncate" v-b-tooltip.hover :title="element.name" triggers="hover">{{element.name}}</p>
                                                    </div>
                                                    <div class="d-flex flex-row-reverse align-items-center col-md-4 col-lg-2 mx-0 px-0">
                                                        <b-button variant="outline-success" class="border-none ml-2" @click="select(element, index)"><i class="las la-plus-circle m-0 p-0"></i></b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </draggable> 
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                            <button type="button" class="d-block btn btn-primary float-right" v-on:click="register">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'
import draggable from 'vuedraggable'

const config = require("../../../../../config");

Vue.use(VueAxios, axios)

export default {
    name: "TagAdd",
    components: {
    draggable,
    },
    data() {
        return {
            tagForm: {
                tag: {
                    name: '',
                    description: '',
                    orderby: ''
                },
                games: []
            },
            gameList: []
        }
    },
    mixins: [validationMixin],
    validations: {
        tagForm: {
            tag: {
                name: { required },
                description: { required },
                orderby: { required, minValue: minValue(1) }
            }
        }
    },
    mounted: async function() {
        try {
            let res = await axios.get(config.api.URL + '/api/gamelib', { params: { m: this.$route.meta.uid } });
            this.gameList = this.convertGameInfo(res.data.all_game);
        } catch(error) {
            alert("Error: Retrieve data error")
            console.log("Error: ", error);
        }
    },
    methods: {
        register: async function() {
            try {
                this.$v.$touch();
                if(!this.$v.$invalid && confirm("Are you sure you want to save this record?")) {
                    for(let i = 0; i < this.tagForm.games.length; i++) {
                        this.tagForm.games[i].index = i + 1;
                    }
                    
                    await axios.post(config.api.URL + '/api/tags/add', this.tagForm, { params: { m: this.$route.meta.uid } });

                    alert("Tag is added successfully.");
                    this.$router.push({path: '/tags/list'});
                }
            } catch(error) {
                alert("Error!")
                console.log("error", error)
            }
        },
        convertGameInfo: function(games) {
            try {
                let convertedGames = [];
                games.forEach(ele => {
                    let game = {
                        name: ele.name,
                        code: ele.code,
                    }
                    
                    convertedGames.push(game);
                });

                return convertedGames;                
            } catch (error) {
                alert("Error!");
                console.log("Error: ", error);
            }
        },
        select: function(game, index) {
            this.gameList.splice(index, 1);
            this.tagForm.games.push(game);
        },
        remove: function(game, index) {
            this.tagForm.games.splice(index, 1);
            this.gameList.push(game);
        }
    }
}
</script>